import { FormattedMessage } from 'react-intl';
import {
  faAddressCard,
  faBookOpen,
  faUniversity,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SearchOption } from '@app/components';
import { sharedMessages } from '@app/translations';

export const AutoCompleteGroups = [
  {
    id: SearchOption.title,
    title: <FormattedMessage {...sharedMessages.title} />,
    icon: <FontAwesomeIcon icon={faBookOpen} />,
  },
  {
    id: SearchOption.author,
    title: <FormattedMessage {...sharedMessages.author} />,
    icon: <FontAwesomeIcon icon={faAddressCard} />,
  },
  {
    id: SearchOption.subject,
    title: <FormattedMessage {...sharedMessages.subject} />,
    icon: <FontAwesomeIcon icon={faUniversity} />,
  },
];
